'use client';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function LocationSection() {
  const landmarks = [
    { name: 'IIM Bangalore', distance: '160 m', icon: 'AcademicCapIcon' },
    { name: 'Electronic City', distance: '8 km', icon: 'BuildingOfficeIcon' },
    { name: 'Bannerghatta National Park', distance: '12 km', icon: 'MapIcon' },
    { name: 'Kempegowda Airport', distance: '45 km', icon: 'GlobeAltIcon' },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-flex items-center space-x-2 text-accent">
              <Icon name="MapPinIcon" size={24} />
              <span className="text-sm font-semibold uppercase tracking-wide">Our Location</span>
            </div>
            <h2 className="text-3xl lg:text-5xl font-display font-bold text-primary">
              Visit Us in Bangalore
            </h2>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Icon name="MapPinIcon" size={24} className="text-accent flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold text-text-primary">Address</p>
                  <p className="text-text-secondary">
                    Proximus Serviced Apartments<br />
                    139/1, 2A, 1, 1st Main Rd<br />
                    Sarvabhoumanagar, Sundar Ram Shetty Nagar<br />
                    Bilekahalli, Bengaluru, Karnataka 560076, India
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Icon name="ClockIcon" size={24} className="text-accent flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold text-text-primary">Reception Hours</p>
                  <p className="text-text-secondary">24/7 - Always Available</p>
                </div>
              </div>
            </div>

            <div className="pt-6">
              <h4 className="font-display text-lg font-semibold text-text-primary mb-4">Nearby Landmarks</h4>
              <div className="grid grid-cols-2 gap-4">
                {landmarks?.map((landmark, index) => (
                  <div key={index} className="flex items-center space-x-3 p-3 bg-muted rounded-lg">
                    <Icon name={landmark?.icon} size={20} className="text-accent" />
                    <div>
                      <p className="text-sm font-medium text-text-primary">{landmark?.name}</p>
                      <p className="text-xs text-text-secondary">{landmark?.distance}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="pt-4">
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 px-6 py-3 bg-accent hover:bg-accent/90 text-white font-semibold rounded-lg shadow-subtle hover:shadow-elevated transition-all duration-300 hover:scale-105"
              >
                <Icon name="MapIcon" size={20} />
                <span>Get Directions</span>
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-premium">
              <AppImage
                src="/assets/images/Entrance-1767660169249.jpg"
                alt="Proximus Serviced Apartments entrance at 139/1, 2A, 1, 1st Main Rd, Bilekahalli, Bengaluru"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-elevated max-w-xs">
              <div className="flex items-center space-x-3 mb-2">
                <Icon name="MapPinIcon" size={24} className="text-accent" />
                <p className="font-semibold text-text-primary">Prime Location</p>
              </div>
              <p className="text-sm text-text-secondary">Strategically located near IIM Bangalore and major corporate hubs</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}